"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MountItem = void 0;
const vue_1 = require("vue");
class MountItem {
    constructor(el) {
        this.el = el;
        this.eventList = {};
        this.watchList = [];
        this.hasFocus = false;
    }
    event(eventName, func) {
        // disable prev event
        const func2 = this.eventList[eventName];
        if (func2 !== undefined) {
            this.el.removeEventListener(eventName, func2);
            delete this.eventList[eventName];
        }
        if (func) {
            this.el.addEventListener(eventName, func);
            this.eventList[eventName] = func;
        }
    }
    watch(watchFunc, func, immediate) {
        const stopFunc = (0, vue_1.watch)(watchFunc, func, (immediate ? { immediate: true } : undefined));
        this.watchList.push(stopFunc);
        return stopFunc;
    }
    unbind() {
        for (const eventName in this.eventList) {
            this.el.removeEventListener(eventName, this.eventList[eventName]);
        }
        this.eventList = {};
        //return true;
        for (const stopFunc of this.watchList) {
            stopFunc();
        }
        this.watchList = [];
    }
}
exports.MountItem = MountItem;
//# sourceMappingURL=MountItem.js.map